import * as React from 'react'
import { CompactLayoutContext } from './CompactLayoutContext'

export function useCompactLayout() {
  const context = React.useContext(CompactLayoutContext)
  return context.layoutState
}
